import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { ParkInfo } from './shared-constants';
import { Observable } from 'rxjs';

@Injectable()
export class ParksService {
	constructor(private db: SpaqFireDb) {}

	getAll(): Observable<any> {
		return this.db.parks$();
	}

	hydrate(): Observable<ParkInfo[]> {
		return this.db.parks$<ParkInfo>();
	}

	parkMeta$(): Observable<any> {
		return this.db.parkMeta$();
	}
}
